import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { getValueUnit } from "../../../general/editUtils";
import SliderInput from "../../../general/SliderInput/index";
import { EditableProps } from "../../editableProps";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { getRotateValue, getStyle, getStylePath, getValueAtPath } from "@builder/components/editable/helpers";
import { FINAL_ICON_LIBRARY } from "@common/utils/finalIconMap";
import ColorInput from "@builder/components/general/ColorInput";

interface StyleIconProps extends EditableProps {
    overrideIconSrc?: string;
}

const StyleIcon: React.FC<StyleIconProps> = ({ path, title, excluded, noWrapper, condition, parent, stateMode, overrideIconSrc }: StyleIconProps) => {
    const dispatch = useAppDispatch();
    const activeNode = useAppSelector(state => state.builder.activeNode);
    const node = useAppSelector(getSelectedNode) as any;
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    //Icon Style
    const iconStyle = getStyle(node, path || ["icon", "style"], stateMode, cvModeIndex);
    const iconStylePath = getStylePath(path || ["icon", "style"], stateMode, cvModeIndex);

    //Icon colors
    const iconName = overrideIconSrc ? overrideIconSrc : getValueAtPath(node, path ? [...path.slice(0, -1), "src"] : ["icon", "src"]);
    const defaultColors = FINAL_ICON_LIBRARY[iconName]?.defaultColors;
    const colors = getStyle(node, path ? [...path.slice(0, -1), "colors"] : ["icon", "colors"], stateMode);
    const colorsPath = getStylePath(path ? [...path.slice(0, -1), "colors"] : ["icon", "colors"], stateMode);

    const size = iconStyle.stateStyle?.width || iconStyle.default?.width;
    const sizeCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...iconStylePath, "width"], value: value + unit }));
        dispatch(updateNodeProperty({ propertyPath: [...iconStylePath, "height"], value: value + unit }));
    };

    let rotateElem = null;
    if (!excluded?.includes("rotate")) {
        const rotate = getRotateValue(iconStyle.stateStyle?.transform || iconStyle.default?.transform) || "0";
        const rotateCallback = (value: string) => {
            dispatch(updateNodeProperty({ propertyPath: [...iconStylePath, "transform"], value: `rotate(${value}deg)`, remove: !value }));
        };
        rotateElem = <SliderInput title="Rotate" value={rotate} unit="" incrementMode min={0} max={360} callback={rotateCallback} />;
    }

    const handleColorChange = (value: string, index: number) => {
        let newColors = [];
        if (Array.isArray(colors.stateStyle) && colors.stateStyle.length > 0) {
            newColors = [...colors.stateStyle];
        } else if (Array.isArray(colors.default) && colors.default.length > 0) {
            newColors = [...colors.default];
        } else {
            newColors = [...defaultColors];
        }
        newColors[index] = value;
        dispatch(updateNodeProperty({ propertyPath: colorsPath, value: newColors }));
    };

    if (condition && (!node || !condition(node, activeNode))) return null;

    if (noWrapper) {
        return (
            <>
                {/* <ColorInput title="Color" color={color} callback={colorCallback} /> */}
                <SliderInput title="Size" {...getValueUnit(size)} min={5} max={100} callback={sizeCallback} />
                {rotateElem}
                {defaultColors &&
                    defaultColors.map((color, index) => (
                        <ColorInput
                            key={index}
                            color={colors.stateStyle?.[index] || colors.default?.[index] || color}
                            callback={(value: string) => handleColorChange(value, index)}
                        />
                    ))}
            </>
        );
    } else {
        return (
            <SidebarCollapse title={title || "Icon"} parent={parent}>
                {/* <ColorInput title="Color" color={color} callback={colorCallback} /> */}
                <SliderInput title="Size" {...getValueUnit(size)} min={5} max={100} callback={sizeCallback} />
                {rotateElem}
                {defaultColors &&
                    defaultColors.map((color, index) => (
                        <ColorInput
                            key={index}
                            color={colors.stateStyle?.[index] || colors.default?.[index] || color}
                            callback={(value: string) => handleColorChange(value, index)}
                        />
                    ))}
            </SidebarCollapse>
        );
    }
};

export default StyleIcon;
